import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { href: "/#about", label: "About" },
    { href: "/#programs", label: "Programs" },
    { href: "/#testimonials", label: "Results" },
    { href: "/#pricing", label: "Pricing" },
    { href: "/booking", label: "Book", isRoute: true },
    { href: "/#contact", label: "Contact" }
  ];

  const isActive = (href) => {
    if (href.startsWith("/#")) {
      return location.pathname === "/" && location.hash === href.replace("/", "");
    }
    return location.pathname === href;
  };

  const renderNavLink = (link) => {
    if (link.isRoute) {
      return (
        <Link
          key={link.href}
          to={link.href}
          className={`nav-link ${isActive(link.href) ? 'active' : ''}`}
          data-testid={`nav-${link.label.toLowerCase()}`}
        >
          {link.label}
        </Link>
      );
    }
    return (
      <a
        key={link.href}
        href={link.href}
        className={`nav-link ${isActive(link.href) ? 'active' : ''}`}
        data-testid={`nav-${link.label.toLowerCase()}`}
      >
        {link.label}
      </a>
    );
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-neutral-900">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 logo-hover" data-testid="header-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_exercise-pathway/artifacts/qpkm0mxh_IMG_20251102_132227_965.webp"
              alt="M.Vision Fitness"
              className="h-12 w-12 object-contain"
            />
            <span className="font-oswald text-xl uppercase tracking-tighter hidden sm:block">
              M.VISION
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => renderNavLink(link))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link to="/assessment" data-testid="header-assessment-btn">
              <button className="bg-mvision-gold text-black font-oswald uppercase tracking-wider text-sm px-6 py-3 hover:bg-mvision-goldLight transition-colors">
                FREE ASSESSMENT
              </button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-black border-t border-neutral-900" data-testid="mobile-menu">
          <nav className="flex flex-col py-4 px-6">
            {navLinks.map((link) => (
              link.isRoute ? (
                <Link
                  key={link.href}
                  to={link.href}
                  className="py-4 border-b border-neutral-900 font-oswald uppercase tracking-wider text-neutral-400 hover:text-white transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ) : (
                <a
                  key={link.href}
                  href={link.href}
                  className="py-4 border-b border-neutral-900 font-oswald uppercase tracking-wider text-neutral-400 hover:text-white transition-colors"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              )
            ))}
            <Link 
              to="/assessment" 
              className="mt-4"
              onClick={() => setMobileMenuOpen(false)}
            >
              <button className="w-full bg-mvision-gold text-black font-oswald uppercase tracking-wider py-4">
                FREE ASSESSMENT
              </button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
